import { ISheetGridField } from '@/interfaces/components'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { VChip, VImg, VLayout, VRow, VSheet, VSpacer, VTooltip } from 'vuetify/lib'
import './SheetGrid.scss'

@Component({})
export class SheetGrid extends Vue {
	@Prop({ type: String }) title!: string
	@Prop({ type: String }) icon!: string
	@Prop({ type: String, default: '32' }) iconWidth!: string
	@Prop({ type: Array }) fields!: Array<ISheetGridField>
	@Prop({ type: Boolean }) action!: boolean
	@Prop({ type: String }) button!: string
	@Prop({ type: String }) text!: string

	render() {
		if (this.fields.length == 0) return

		return (
			<VLayout class="sheetgrid-container">
				<VSheet class="pa-5 mt-5" color="#f3f3f3" width="100%">
					<VRow align="center" class="pa-4">
						{this.icon && <VImg src={this.icon} max-width={this.iconWidth} contain class="mr-4" />}
						<span class="title-sheetgrid">{this.title}</span>
						<VSpacer />
						{this.action && (
							<VTooltip
								color="primary"
								bottom
								scopedSlots={{
									activator: ({ on }: { on: any }) => (
										<VChip class="mr-2 mx-10 ml-3" on={on}>
											{this.button}
										</VChip>
									)
								}}
							>
								<span>{this.text}</span>
							</VTooltip>
						)}
					</VRow>
					<VRow class="pa-2">{this.fields.map(this.renderFieldItem)}</VRow>
				</VSheet>
			</VLayout>
		)
	}

	renderFieldItem(field: ISheetGridField) {
		return (
			<VSheet height="auto" width="100%" class="d-flex my-2 pa-4">
				<span data-cy={field.dataCy} class="sheetgrid-content-text">
					{field.field}
				</span>
				<VSpacer style={{ width: '60px' }} />
				<span style={{ textAlign: 'right' }} class="sheetgrid-content-text-bold">
					{field.value}
				</span>
			</VSheet>
		)
	}

	@Watch('fields', { deep: true })
	onFieldsChange(val: Array<ISheetGridField>, oldVal: Array<ISheetGridField>) {
		this.fields = val
	}
}

export default SheetGrid
